import React from "react";
import { ChartNew } from "../../../../../components";

const BarChartList = () => {
  const rawData = [
    { Month: "Jan", Revenue: 11, Invoices: 70 },
    { Month: "Feb", Revenue: 29, Invoices: 70 },
    { Month: "Mar", Revenue: 44, Invoices: 70 },
    { Month: "Apr", Revenue: 60, Invoices: 70 },
    { Month: "May", Revenue: 31, Invoices: 70 },
    { Month: "Jun", Revenue: 18, Invoices: 70 },
  ];

  const renderExpandContent = () => (
    <div className="grid grid-cols-4 gap-5 mx-15 py-4">
      <div className="flex flex-col bg-success-50 border border-success rounded-xl p-4 ">
        <span className="text-success-700 text-2xl font-semibold">$610</span>
        <p className="py-2">Total Revenue</p>
        <span className="text-success text-sm">100% of Data</span>
      </div>

      <div className="flex flex-col bg-info-50 border border-info rounded-xl p-4 ">
        <span className="text-info-700 text-2xl font-semibold">$180</span>
        <p className="py-2">Peak Value</p>
        <span className="text-info text-sm">Best Period</span>
      </div>

      <div className="flex flex-col bg-leave-50 border border-leave rounded-xl p-4 ">
        <span className="text-leave-700 text-2xl font-semibold">$122</span>
        <p className="py-2">Average</p>
        <span className="text-leave text-sm">Per Period</span>
      </div>

      <div className="flex flex-col bg-warning-50 border border-warning rounded-xl p-4 ">
        <span className="text-warning-700 text-2xl font-semibold">5</span>
        <p className="py-2">Time Periods</p>
        <span className="text-warning text-sm">Data Points</span>
      </div>
    </div>
  );

  const renderAreaChartTooltip = (data) => (
    <div className="flex flex-col gap-3 text-sm">
      <span className="text-primary">{data.label}</span>
      <div className="bg-primary-50 text-gray-600 text-xs font-medium w-[100px] flex justify-between p-2 rounded shadow-md">
        Revenue: <span className="text-primary">{data.Revenue}</span>
      </div>
    </div>
  );

  return (
    <div className="grid grid-cols-2 gap-5 bg-gray-100 p-2">
      <div className="h-[400px] bg-white rounded-lg p-3">
        <ChartNew
          type="barchart"
          title="Sales Performance"
          // steps={5}
          rawData={rawData}
          chartLabel={"Month"}
          chartValue={"Revenue"}
          // formatYAxisTick={(val) => `$ ${val}`}
          expandedContent={renderExpandContent()}
          expandedChartWidth="w-[70%]"
          expandedChartHeight="h-[400px]"
          formatYAxisTick={(val) => `$ ${val}`}
          barChartProps={{
            steps: 5,
          }}
          areaChartProps={{
            steps: 5,
          }}
        />
      </div>
      <div className="h-[400px] bg-white rounded-lg p-3">
        <ChartNew
          tableChartProps={{
            hideToolBar: false,
          }}
          title=""
          barColors={[
            { color: "primary" },
            { color: "info" },
            { color: "leave" },
            { color: "draft", depth: 500 },
            { color: "success" },
          ]}
          rawData={[
            { Month: "Jan", Revenue: 11, Invoices: 70 },
            { Month: "Feb", Revenue: 29, Invoices: 70 },
            { Month: "Mar", Revenue: 44, Invoices: 70 },
            { Month: "Apr", Revenue: 60, Invoices: 70 },
            { Month: "May", Revenue: 31, Invoices: 70 },
            { Month: "Jun", Revenue: 18, Invoices: 70 },
            { Month: "Jul", Revenue: 11, Invoices: 70 },
            { Month: "Aug", Revenue: 29, Invoices: 70 },
            { Month: "Sep", Revenue: 44, Invoices: 70 },
            { Month: "Oct", Revenue: 60, Invoices: 70 },
            { Month: "Nov", Revenue: 31, Invoices: 70 },
            { Month: "Dec", Revenue: 18, Invoices: 70 },
          ]}
          dateRangeValue={{
            from: "2025-09-02T18:30:00.000Z",
            to: null,
          }}
          chartLabel={"Month"}
          chartValue={"Revenue"}
          chartToolbarRight={{
            date: true,
            expand: true,
            filter: true,
            compare: true,
            screenShare: true,
            dateValue: {
              from: "2025-09-02T18:30:00.000Z",
              to: "2025-09-06T18:30:00.000Z",
            },
          }}
          formatYAxisTick={(val) => `Rs ${val}`}
          barChartProps={{
            depth: 300,
          }}
          areaChartProps={{
            steps: 5,
            renderToolTip: (data) => renderAreaChartTooltip(data),
          }}
        />
      </div>

      <div className="col-span-2 h-[400px] bg-white rounded-lg p-3">
        <ChartNew
          barColors={[
            { color: "primary" },
            { color: "info" },
            { color: "leave" },
            { color: "draft", depth: 500 },
            { color: "success" },
          ]}
          chartToolbarRight={{
            filter: true,
          }}
          rawData={[
            { Month: "Jan", Revenue: 11, Invoices: 70 },
            { Month: "Feb", Revenue: 29, Invoices: 70 },
            { Month: "Mar", Revenue: 44, Invoices: 70 },
            { Month: "Apr", Revenue: 60, Invoices: 70 },
            { Month: "May", Revenue: 31, Invoices: 70 },
            { Month: "Jun", Revenue: 18, Invoices: 70 },
          ]}
          chartLabel={"Month"}
          chartValue={"Revenue"}
          title="Monthly Revenue"
          barChartProps={{
            depth: 300,
          }}
          areaChartProps={{
            depth: 300,
          }}
        />
      </div>
    </div>
  );
};

export default BarChartList;
